import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {paypalDescription, type PayPalGateway} from './paypal';

import paypalBadgeURL from '../../../img/badge/paypal.svg';
import paypalCreditImageURL from '../../../img/marks/paypal.svg';
import {PayPalPaymentButton} from './class-paypal-payment';
import {type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../../@type/features';
import {Feature} from '../../reducers/environmentReducer';
import {store} from '../../store';
import {render} from '../../reducers/rootReducer';

function initPayPalCreditMethod(): PayPalGateway {
	let buttonInstance: PayPalPaymentButton | null = null;

	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.PAYPAL_CREDIT_GATEWAY, 'title') ?? 'PayPal Credit',
		gatewayId: 'peachpay_paypal_credit',
		description: paypalDescription('PayPal Credit', paypalCreditImageURL, 'After selecting the PayPal Credit button you will be prompted to complete your payment.'),
		assets: {
			badge: {src: paypalBadgeURL},
			title: {src: paypalCreditImageURL},
		},
	};

	return {
		config,
		activate(paypal, orderService) {
			buttonInstance = new PayPalPaymentButton(paypal, orderService, {
				gatewayId: 'peachpay_paypal_credit',
				fundingType: 'credit',
				buttonStyle: Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_CREDIT_GATEWAY, 'button_style') ?? undefined,
			});
			config.initialized = buttonInstance.isEligible();
			store.dispatch(render());
		},
		reset() {
			buttonInstance?.unmount();
			buttonInstance = null;
			config.initialized = false;
			store.dispatch(render());
		},
		attach(selector) {
			buttonInstance?.mount(selector);
		},
		detach() {
			buttonInstance?.unmount();
		},
	};
}

export {
	initPayPalCreditMethod,
};
